define.alias("shared/components/shared/ui/notification-banner", "settings/components/shared/ui/notification-banner");